/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { TrainClass }    from './train.class';
import { DecisionPoint } from './decision.point';

/**
 *
 * @class Penalty
 *
 * @brief the time penalties for a given train class and decision point (a set of switches).
 * The penalties are all pre-calculated for us, things like the delay for having to accelerate
 * from stop etc.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class Penalty {

  /** @var _id the unique id for this penalty */
  public               _id: number             = -1;

  /** @var _tc the train class this penalty belongs to */
  public               _tc: TrainClass|null    = null;

  /** @var _dp the decision point where this penalty applies */
  public               _dp: DecisionPoint|null = null;

  /** @var _clearTime clearance time for this connection */
  public        _clearTime: number             = 0.0;

  /** @var _clearTimeStopped clearance time for this connection, if train was stopped */
  public _clearTimeStopped: number             = 0.0;

  /** @var _turnoutAccel back to track speed from restriction */
  public     _turnoutAccel: number             = 0.0;

  /** @var _turnoutDecel  down to restriction from track speed */
  public     _turnoutDecel: number             = 0.0;

  /** @var _stopAccel from a stop (includes taking the turnout if applicable) */
  public        _stopAccel: number             = 0.0;

  /** @var _stopDecel from a stop (includes taking turnout if applicable) */
  public        _stopDecel: number             = 0.0;

  /** @var _headway min train spacing in hours if lead train taking this connection */
  public          _headway: number             = 0.0;

  /** @var _headwayStop min train spacing if train was stopped taking this connection */
  public      _headwayStop: number             = 0.0;

  /** @var _headwaySlow min train spacing in hours if slow order active */
  public      _headwaySlow: number             = 0.0;

  /** @var _speed the switch speed */
  public            _speed: number            = 0.0;

  /** @var _nth the zero based index for this item */
  public              _nth: number             = -1;

  /** @brief standard constructor */
  constructor( id: number,
               tc: TrainClass|null,
               dp: DecisionPoint|null,
               ct: number,
              cts: number,
               ta: number,
               td: number,
               sa: number,
               sd: number,
                h: number,
               hs: number,
              hsl: number,
                s: number,
              nth: number) {

    this._id               = id;
    this._tc               = tc;
    this._dp               = dp;
    this._clearTime        = ct;
    this._clearTimeStopped = cts;
    this._turnoutAccel     = ta;
    this._turnoutDecel     = td;
    this._stopAccel        = sa;
    this._stopDecel        = sd;
    this._headway          = h;
    this._headwayStop      = hs;
    this._headwaySlow      = hsl;
    this._speed            = s;
    this._nth              = nth;
  }
}
